module.exports = __webpack_public_path__ + "media/images/application/template/icon-select-b01d26467e6c49bfce7a619693b3223a.svg";